








































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { EmployerUser } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import { useEmployerUserStore } from "@/shared/store/employerUser";

@Component
export default class ManageEmployerUserForm extends Vue {
  themeStore = useThemeStore();
  employerUserStore = useEmployerUserStore();

  @Prop()
  employerUser: EmployerUser;

  employerUserModel: EmployerUser = null;

  mounted (): void {
    this.employerUserModel = { ...this.employerUser };
  }

  @Watch("employerUser")
  updateEmployerUserModel (): void {
    this.employerUserModel = { ...this.employerUser };
  }

  get submitDisabled (): boolean {
    return this.$validator.errors.any() || this.employerUserStore.postingUpdate;
  }

  get emailInputDisabled (): boolean {
    return this.employerUser && (this.employerUser.userHsaEnrolled || this.employerUser.isConfirmed);
  }

  onSubmit (): void {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.employerUserStore.updateEmployerUser(this.employerUserModel).then(result => {
            if (!result.updateError) {
              this.toggleModal();
            }
          });
        });
  }

  toggleModal (): void {
    this.$root.$emit("bv::toggle::modal", "employer-user-edit-modal", "#modal-toggle");
  }
}
